import React from "react";
import { connect } from "react-redux";
import  { Navigate } from 'react-router-dom'

import { doSignIn, doSignUp } from "../stores/thunk";

const Auth = (Component) => {
  class Container extends React.Component {
    render() {
      const { auth } = this.props;
      return auth.authenticated ? (
        <Navigate to={auth.redirectUrl || '/'} />
      ) : (
        <Component {...this.props} />
      );
    }
  }
  function mapStateToProps(state) {
    return {
      auth: state.auth,
    };
  }
  return connect(mapStateToProps, { doSignIn, doSignUp })(
    Container
  );
};

export default Auth;